import { useMemo, useState } from 'react';
import { ChevronRightIcon, ChevronDownIcon } from '../../automationStudioIcons';
import styles from '../../../../styles/automationStudio/automationStudio.module.scss';
import { extractToolResponseText } from '../../../AutomationStudio/utils/toolOutputExtract';
import {
    buildTeaser,
    ConsoleBody,
    EvaluateBody,
    NETWORK_REQUEST_TOOL,
    NetworkBody,
    parseConsoleLines,
    parseNetworkRequestsForDisplay,
} from './toolOutputHelpers';

export default function ToolOutput({ step, stepDetails }) {
    const [open, setOpen] = useState(false);
    const tool = step?.tool;

    const supported =
        tool === NETWORK_REQUEST_TOOL || tool === 'browser_evaluate' || tool === 'browser_console_messages';

    const text = useMemo(
        () => (supported ? extractToolResponseText(step, stepDetails) : null),
        [supported, step, stepDetails]
    );

    const networkRows = useMemo(
        () => (tool === NETWORK_REQUEST_TOOL && text ? parseNetworkRequestsForDisplay(text) : []),
        [tool, text]
    );
    const consoleRows = useMemo(
        () => (tool === 'browser_console_messages' && text ? parseConsoleLines(text) : []),
        [tool, text]
    );

    if (!supported) return null;

    const teaser = buildTeaser(tool, text);
    const hasBody = !!text;

    return (
        <div className={styles.toolOutputBlock}>
            <button
                type="button"
                className={styles.toolOutputHeader}
                onClick={(e) => {
                    e.stopPropagation();
                    if (hasBody) setOpen((o) => !o);
                }}
                aria-expanded={open && hasBody}
                disabled={!hasBody}
            >
                {hasBody &&
                    (open ? (
                        <ChevronDownIcon className={styles.toolOutputChevron} />
                    ) : (
                        <ChevronRightIcon className={styles.toolOutputChevron} />
                    ))}
                <span className={styles.toolOutputLabel}>Tool output</span>
                {teaser && <span className={styles.toolOutputTeaser}>{teaser}</span>}
            </button>
            {open && hasBody && (
                <div className={styles.toolOutputBody} onClick={(e) => e.stopPropagation()}>
                    {tool === NETWORK_REQUEST_TOOL && <NetworkBody rows={networkRows} rawText={text} />}
                    {tool === 'browser_console_messages' && <ConsoleBody rows={consoleRows} rawText={text} />}
                    {tool === 'browser_evaluate' && <EvaluateBody rawText={text} />}
                </div>
            )}
        </div>
    );
}
